// Local translations
export const T = {
  en_GB: {
    pageNotFound: "Page not found",
    settings: "Settings",
    flows: "Flows",
    backToPages: "Back to Pages",
    internal: "Internal",
    public: "Public",
    goalPage: "Goal Page",
    portfolioPage: "Portfolio Page",
    globalPage: "Global Page",
    conditionalVisibility: "Conditional Visibility",
    dragAndDropHint: "Drag and drop to reorder components",
    pageSettings: "Page Settings",
    add2ColumnBlock: "Add 2-Column Block",
    addTabsBlock: "Add Tabs Block",
    addComponent: "Add Component",
    add: "Add",
    component: "Component",
    tabBlock: "Tab Block",
    twoColumnBlockLabel: "2-Column Block",
    noComponentsYet: "No components yet.",
    addComponentsHint: "Add components or 2-column blocks to make this page functional.",
    movingComponent: "Moving component...",
    required: "Required",
    conditional: "Conditional",
    needsSetup: "Needs flow setting",
    deleteComponent: "Delete Component",
    deleteComponentDescription:
      "Are you sure you want to delete this component? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    deleting: "Deleting...",
    error: "Error",
    failedToDeleteComponent: "Failed to delete component",
    duplicateComponent: "Duplicate component",
    failedToDuplicateComponent: "Failed to duplicate component",
    failedToCreateBlock: "Failed to create",
    twoColumnBlock: "2-column",
    tabsBlock: "tabs",
    block: "block",
    deleteTabsBlock: "Delete Tabs Block",
    delete2ColumnBlock: "Delete 2-Column Block",
    tabsComponentsMoved: "Components in all tabs will be moved to the page.",
    columnComponentsFullWidth: "Components in this block will become full-width. Continue?",
    failedToDeleteLayout: "Failed to delete layout block",
    deleteTab: "Delete Tab",
    deleteTabDescription: "Components in this tab will be moved to the end of the page.",
    failedToAddTab: "Failed to add tab",
    failedToDeleteTab: "Failed to delete tab",
    failedToRenameTab: "Failed to rename tab",
    failedToReorderComponents: "Failed to reorder components",
    failedToMoveComponent: "Failed to move component",
    failedToReorderItems: "Failed to reorder items",
    ok: "OK",
    costProjectionChart: "Cost Projection Chart",
  },
  nb_NO: {
    pageNotFound: "Fant ikke siden",
    settings: "Innstillinger",
    flows: "Flyter",
    backToPages: "Tilbake til sider",
    internal: "Intern",
    public: "Offentlig",
    goalPage: "Målside",
    portfolioPage: "Porteføljeside",
    globalPage: "Global side",
    conditionalVisibility: "Betinget synlighet",
    dragAndDropHint: "Dra og slipp for å endre rekkefølge på komponenter",
    pageSettings: "Sideinnstillinger",
    add2ColumnBlock: "Legg til 2-kolonneblokk",
    addTabsBlock: "Legg til faneblokk",
    addComponent: "Legg til komponent",
    add: "Legg til",
    component: "Komponent",
    tabBlock: "Faneblokk",
    twoColumnBlockLabel: "2-kolonneblokk",
    noComponentsYet: "Ingen komponenter ennå.",
    addComponentsHint:
      "Legg til komponenter eller 2-kolonneblokker for å gjøre denne siden funksjonell.",
    movingComponent: "Flytter komponent...",
    required: "Påkrevd",
    conditional: "Betinget",
    needsSetup: "Mangler flytinnstilling",
    deleteComponent: "Slett komponent",
    deleteComponentDescription:
      "Er du sikker på at du vil slette denne komponenten? Denne handlingen kan ikke angres.",
    cancel: "Avbryt",
    delete: "Slett",
    deleting: "Sletter...",
    error: "Feil",
    failedToDeleteComponent: "Kunne ikke slette komponent",
    duplicateComponent: "Dupliser komponent",
    failedToDuplicateComponent: "Kunne ikke duplisere komponent",
    failedToCreateBlock: "Kunne ikke opprette",
    twoColumnBlock: "2-kolonne",
    tabsBlock: "fane",
    block: "blokk",
    deleteTabsBlock: "Slett faneblokk",
    delete2ColumnBlock: "Slett 2-kolonneblokk",
    tabsComponentsMoved: "Komponenter i alle faner vil bli flyttet til siden.",
    columnComponentsFullWidth: "Komponenter i denne blokken vil bli fullbredde. Fortsette?",
    failedToDeleteLayout: "Kunne ikke slette layoutblokk",
    deleteTab: "Slett fane",
    deleteTabDescription: "Komponenter i denne fanen vil bli flyttet til slutten av siden.",
    failedToAddTab: "Kunne ikke legge til fane",
    failedToDeleteTab: "Kunne ikke slette fane",
    failedToRenameTab: "Kunne ikke endre navn på fane",
    failedToReorderComponents: "Kunne ikke endre rekkefølge på komponenter",
    failedToMoveComponent: "Kunne ikke flytte komponent",
    failedToReorderItems: "Kunne ikke endre rekkefølge på elementer",
    ok: "OK",
    costProjectionChart: "Kostnadsframskrivning",
  },
} as const;
